import { useTranslation } from '../../../../../components/Translation';

export type CardProps = {
  header: string;
  title: string;
  image: string;
  doc: string;
};

export default function Card({ header, title, image, doc }: CardProps) {
  const { t } = useTranslation();
  return (
    <div
      className="w-full h-[92vh] min-h-[500px] bg-cover bg-center relative"
      style={{ backgroundImage: `url(${image})` }}
    >
      {/* Dark overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0d1f35]/60 via-[#0d1f35]/40 to-[#0d1f35]/80" />
      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end px-8 pb-24 max-w-3xl">
        <p className="text-dorado-uady text-mini font-semibold uppercase tracking-widest mb-3">
          - {t(`laboratorio.${header}`)}
        </p>
        <h2 className="text-white text-4xl md:text-5xl font-bold leading-tight mb-4">
          {t(`laboratorio.${title}`)}
        </h2>
        <a
          href={doc}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-white/80 hover:text-dorado-uady text-mini transition-colors"
        >
          {t('laboratorio.seguir')}
        </a>
      </div>
    </div>
  );
}
